import Home from "@/modules/home/components/Home";

export default [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
];



// WEBPACK FOOTER //
// ./src/modules/home/router/home.js